import type { IAuditLogChangeGroup } from 'components/common/audit-logs/types.ts';
import { BaseAuditLogService } from './base-audit-log-service.ts';
import type { IAuditLogService, TAuditMessageSegment } from './types.ts';

export class ClientAuditLogService extends BaseAuditLogService implements IAuditLogService {
  public override get messageSegments(): TAuditMessageSegment[] {
    switch (this.auditLog.action) {
      case 'client_block_status_changed':
        return this.blockStatusChangedMessageSegments;
      case 'client_credit_limit_changed':
        return this.creditLimitChangedMessageSegments;
      default:
        return super.messageSegments;
    }
  }

  public override get changeGroups(): IAuditLogChangeGroup[] {
    switch (this.auditLog.action) {
      case 'client_block_status_changed':
        return [];
      default:
        return super.changeGroups;
    }
  }

  private get blockStatusChangedMessageSegments(): TAuditMessageSegment[] {
    const isBlocked = this.getChange('isBlocked')?.new;

    const action = isBlocked ? 'blocked' : 'unblocked';

    return [this.text(this.actor), this.text(action), this.text('customer')];
  }

  private get creditLimitChangedMessageSegments(): TAuditMessageSegment[] {
    return [this.text(`${this.actor} changed customer credit limit`)];
  }
}
